import React from "react";
import { Drawer, Form, Input, Select, InputNumber } from "antd";
import { FormInstance } from "antd/lib/form";
import { drawerFooter } from "../../../components";

interface BankAccountFormDrawerProps {
  open: boolean;
  isCreatingAccount: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: FormInstance;
  createPending: boolean;
  updatePending: boolean;
}

export const BankAccountFormDrawer: React.FC<BankAccountFormDrawerProps> = ({
  open,
  isCreatingAccount,
  onClose,
  onSubmit,
  form,
  createPending,
  updatePending,
}) => {
  return (
    <Drawer
      title={
        isCreatingAccount
          ? "Register Bank Account"
          : "Edit Bank Account Details"
      }
      width={600}
      open={open}
      onClose={onClose}
      footer={drawerFooter({
        actions: [
          {
            label: "Cancel",
            onClick: onClose,
          },
          {
            label: "Save Account",
            type: "primary",
            loading: createPending || updatePending,
            onClick: onSubmit,
          },
        ],
      })}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="account_name"
          label="Account Name / Holder"
          rules={[
            { required: true, message: "Please input account holder name" },
          ]}
        >
          <Input placeholder="e.g. Primary Store Cash Book" />
        </Form.Item>

        <Form.Item
          name="account_number"
          label="Account Number"
          rules={[{ required: true, message: "Please input account number" }]}
        >
          <Input placeholder="Enter account number" />
        </Form.Item>

        <Form.Item
          name="bank_name"
          label="Bank Name"
          rules={[{ required: true, message: "Please input bank name" }]}
        >
          <Input placeholder="e.g. Commercial Bank of Ceylon" />
        </Form.Item>

        <Form.Item name="bank_branch" label="Branch Name">
          <Input placeholder="e.g. Colombo Fort Branch" />
        </Form.Item>

        <Form.Item
          name="currency"
          label="Currency"
          rules={[{ required: true, message: "Currency is required" }]}
        >
          <Select
            options={[
              { value: "LKR", label: "LKR - Sri Lankan Rupee" },
              { value: "USD", label: "USD - US Dollar" },
            ]}
          />
        </Form.Item>

        {isCreatingAccount && (
          <Form.Item
            name="balance"
            label="Starting Balance"
            rules={[
              { required: true, message: "Please enter starting balance" },
            ]}
          >
            <InputNumber
              className="w-full"
              min={0}
              precision={2}
              placeholder="0.00"
              formatter={(val) =>
                `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(val) => val!.replace(/\$\s?|(,*)/g, "") as any}
            />
          </Form.Item>
        )}
      </Form>
    </Drawer>
  );
};
